<template>
    <transition name="modal">
        <div @click="closeModal" class="screen-area">
            <div @click.stop class="custom-modal z-depth-3">
                <slot>
                    <div class="prompt">
                        <h5>Are you sure?</h5>
                        <div class="buttons_wrapper">
                                                    <a @click="closeModal" class="waves-effect waves-light btn btn-delete"><i class="material-icons">cancel</i></a>
                        <a @click="accept" class="waves-effect waves-light btn btn-complete"><i class="material-icons">done</i></a>
                        </div>
                    </div>
                </slot>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  data () {
    return {
      animate: false
    }
  },
  computed: {
    active () {
      return this.value
    }
  },
  methods: {
    closeModal () {
      this.$emit('close', false)
      this.$emit('clearFields')
    },
    accept () {
      this.$emit('accept')
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
    .screen-area {
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(71, 71, 71, 0.486);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 100;
        overflow: hidden;
        display: flex;
        .custom-modal {
            background-color: #fff;
            padding: 20px 30px;
        }
    }

    .prompt{
        display: flex;
        flex-direction: column;
        align-items: center;
        .buttons_wrapper{
            margin-top: 20px;
        }
    }

    .modal-enter.screen-area,
    .modal-leave-to.screen-area {
        background-color: rgba(71, 71, 71, 0);
    }

    .modal-enter-active.screen-area,
    .modal-leave-active.screen-area {
        transition: background-color .7s;
    }

    .modal-enter-active .custom-modal {
        animation: modal .7s
    }

    .modal-leave-to .custom-modal {
        transform: translateY(500px)
    }

    .modal-leave-active .custom-modal {
        transition: transform .7s;
    }

    @keyframes modal {
        0% {
            transform: scale(0);
        }
        75% {
            transform: scale(1.2);
        }
        100% {
            transform: scale(1);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modal.vue